import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';

type HelperResubmitSettlementBannerProps = {
  mainBudgetId: string;
};

export const HelperResubmitSettlementBanner = ({ mainBudgetId }: HelperResubmitSettlementBannerProps) => {
  const { t } = useLanguage();
  const helperConfirmHref = `/settlements/confirm?mainBudgetId=${encodeURIComponent(mainBudgetId)}`;

  return (
    <div
      className="flex gap-3 rounded-xl border border-amber-100 bg-amber-50/90 p-3 dark:border-amber-900/40 dark:bg-amber-950/30"
      role="note"
      aria-live="polite"
    >
      <svg
        className="mt-0.5 h-5 w-5 shrink-0 text-amber-700 dark:text-amber-400"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        aria-hidden
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 8v4m0 4h.01M10.29 3.86l-8 14A1 1 0 003.16 19h17.68a1 1 0 00.87-1.5l-8-14a1 1 0 00-1.74 0z"
        />
      </svg>
      <p className="text-sm leading-relaxed text-amber-900 dark:text-amber-100/90">
        {t('settlement.helperResubmitBannerPrefix')}
        <Link
          to={helperConfirmHref}
          className="font-semibold text-primary-700 underline decoration-primary-400 underline-offset-2 hover:text-primary-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 dark:text-primary-300 dark:hover:text-primary-200"
          aria-label={t('settlement.helperResubmitBannerLinkAria')}
        >
          {t('settlement.helperResubmitBannerLink')}
        </Link>
        {t('settlement.helperResubmitBannerSuffix')}
      </p>
    </div>
  );
};
